import _ from 'lodash'
import type {CssValue} from '../../constants'
import type {VectorImageShadow} from '@wix/document-services-types'
import {deserializeColor, serializeColor} from '../utils/color'
import {deserializeUnit, serializeUnit} from '../utils/unit'

const SHADOW_UNIT_SIZE = 'px'
const VALID_TYPES_SET = new Set([SHADOW_UNIT_SIZE])

const serializeUnitValue = (value: number) => serializeUnit({value, type: SHADOW_UNIT_SIZE}, VALID_TYPES_SET)
const deserializeUnitValue = (value: CssValue) => deserializeUnit(value, VALID_TYPES_SET)?.value

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {x, y, blurRadius, opacity, color} = val

    if (!_.isNumber(x) || !_.isNumber(y) || !_.isNumber(blurRadius) || !_.isNumber(opacity) || !_.isString(color)) {
        return undefined
    }

    const serializedColor = serializeColor({value: color, alpha: opacity.toString()})
    const serializedX = serializeUnitValue(x)
    const serializedY = serializeUnitValue(y)
    const serializedBlurRadius = serializeUnitValue(blurRadius)

    return `${serializedColor} ${serializedX} ${serializedY} ${serializedBlurRadius}`
}

const deserialize = (rule: CssValue): VectorImageShadow | undefined => {
    const [serializedColor, serializedX, serializedY, serializedBlurRadius] = rule?.split(' ')

    if (!serializedColor || !serializedX || !serializedY || !serializedBlurRadius) {
        return undefined
    }

    const x = deserializeUnitValue(serializedX)
    const y = deserializeUnitValue(serializedY)
    const blurRadius = deserializeUnitValue(serializedBlurRadius)

    if (!_.isNumber(x) || !_.isNumber(y) || !_.isNumber(blurRadius) || !_.isString(serializedColor)) {
        return undefined
    }

    const {value, alpha} = deserializeColor(serializedColor) ?? {}

    if (!_.isString(value) || _.isUndefined(alpha) || !_.isNumber(+alpha)) {
        return undefined
    }

    return {
        x,
        y,
        blurRadius,
        opacity: +alpha,
        color: value
    }
}

export default {
    serialize,
    deserialize
}
